import { render } from "./MediumFeed.vue?vue&type=template&id=b29a9794&scoped=true"
import script from "./MediumFeed.vue?vue&type=script&lang=js"
export * from "./MediumFeed.vue?vue&type=script&lang=js"

import "./MediumFeed.vue?vue&type=style&index=0&id=b29a9794&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b29a9794"]])

export default __exports__